import React from 'react'
import { ContactBox } from './contactbox'
import { faPhoneAlt, faEnvelope, faMapMarkedAlt } from '@fortawesome/free-solid-svg-icons'

export default function Contact(){
    return (
        <div className="footer-first-block">
            <div className="row">
                <ContactBox Icon={faPhoneAlt} Title="Phone" Content="Promising development turmoil inclusive education transformative community"
                    Link="tel:+91 7584859649" Name="+91 7584859649" />
                <ContactBox Icon={faEnvelope} Title="Email" Content="Promising development turmoil inclusive education transformative community"
                Link="mailto:demo@demo.com" Name="demo@demo.com" />
                <ContactBox Icon={faMapMarkedAlt} Title="Location" Content="321 ,Block 1st Cross, Near Woodstock Los Angeles, USA "
                Link="https://www.google.com/maps" Name="View on Google map" />
            </div>
        </div>
    )
}